<template>
  <div class="form-box">
    <vue-headful
      title="Parent Onboarding - Add Child | Gradelyng"
      description="Description goes here"
    />

    <success-modal
      @closeTriggered="$router.push({ name: 'ParentFeeds', query: { id: 0 } })"
      v-if="show_success_modal"
    />

    <div class="onboarding-section">
      <!-- CLOSE TRIGGER -->
      <div
        class="pageClose dialogDismiss"
        @click="$router.push({ name: 'ParentSettingsPreferences' })"
      >
        <button
          type="button"
          class="close_dialog cls_lg transparent_bg"
        ></button>
      </div>
      <!-- CLOSE TRIGGER -->

      <div class="container onboarding-wrapper">
        <summer-school-form
          @connectedToSummerSchool="show_success_modal = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { bgColorSetter } from "@/scripts/utilities";
import SummerSchoolForm from "@/components/parentsComps/onboarding/SummerSchoolForm";
import SuccessModal from "@/components/modalComps/settingsModals/SuccessModal";

export default {
  name: "SummerSchoolOnboardingOne",

  components: {
    SummerSchoolForm,
    SuccessModal,
  },

  mounted() {
    bgColorSetter("#f0f0f0");
  },

  data() {
    return {
      show_success_modal: false,
    };
  },
};
</script>

<style lang="scss">
.onboarding-section {
  .onboarding-bottom {
    margin: 50px auto 60px;
  }
}
</style>
